module.exports = __webpack_public_path__ + "static/media/16_sognolucido.bea7d912.jpg";